import Vue from 'vue'
import Sentry from '~/util/sentry'
import Router from 'vue-router'
import App from '~/components/homehub/Landing/App.vue'
import axios from '~/util/axios'
import apolloClient from '~/util/apolloClient'
import vuetify from '~/util/vuetify.js'
import datadog from '~/util/datadog.js'
import { store } from '~/store/onboardingStore.js'
import snackbard from 'snackbard'

const { VueApollo, provider } = apolloClient()
datadog({ packName: 'landingPage' })

Vue.prototype.$sentry = Sentry([{ key: 'pack', value: 'New Landing Page' }])
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.config.devtools = true
Vue.use(snackbard)
Vue.use(Router)
Vue.use(VueApollo)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/homehub/signup/:code?',
      name: 'newLandingPage',
      component: () => import('~/components/homehub/Landing/LandingPage.vue')
    },
    {
      path: '/homehub/login/:code?',
      name: 'onboardingWrapper',
      component: () => import('~/components/homehub/Onboarding/OnboardingWrapper.vue')
    },
    {
      path: '/homehub/onboarding/:code/ask-for-email',
      name: 'askForEmail',
      component: () => import('~/components/homehub/Onboarding/AskForEmail.vue')
    },
    {
      path: '/homehub/onboarding/:code/recover-password',
      name: 'recoverPassword',
      component: () => import('~/components/homehub/Onboarding/RecoverPassword.vue')
    },
    {
      path: '/homehub/onboarding/:code/recover-password-sent',
      name: 'recoverPasswordSent',
      component: () => import('~/components/homehub/Onboarding/RecoverPasswordSent.vue')
    },
    {
      path: '/homehub/onboarding/:code/set-password',
      name: 'setPassword',
      component: () => import('~/components/homehub/Onboarding/SetPassword.vue')
    },
    {
      path: '/homehub/onboarding/:code/multiple-loan-officers',
      name: 'multipleLoanOfficers',
      component: () => import('~/components/homehub/Onboarding/MultipleLoanOfficers.vue')
    },
    {
      path: '/homehub/onboarding/:code/uncommon-scenario',
      name: 'uncommonScenario',
      component: () => import('~/components/homehub/Onboarding/Uncommon.vue')
    },
    {
      path: '/homehub/onboarding/:code/register-account',
      name: 'registerAccount',
      component: () => import('~/components/homehub/Onboarding/RegisterAccount.vue')
    },
    {
      path: '/homehub/onboarding/:code/send-verification-code',
      name: 'sendVerificationCode',
      component: () => import('~/components/homehub/Onboarding/SendVerificationCode.vue')
    },
    {
      path: '/homehub/onboarding/:code/enter-verification-code',
      name: 'enterVerificationCode',
      component: () => import('~/components/homehub/Onboarding/EnterVerificationCode.vue')
    },
    {
      path: '/homehub/onboarding/:code/success',
      name: 'success',
      component: () => import('~/components/homehub/Onboarding/Success.vue')
    },
    {
      path: '/homehub/onboarding/:code/select-loan-officer',
      name: 'selectLoanOfficer',
      component: () => import('~/components/homehub/Onboarding/SelectLoanOfficer.vue')
    }
  ]
})

new Vue({
  router,
  apolloProvider: provider,
  vuetify,
  render: h => h(App)
}).$mount('#app-container')
